import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=5747f7fa&scoped=true&"
import script from "./deleteAccount.vue?vue&type=script&lang=js&"
export * from "./deleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5747f7fa",
  null
  
)

export default component.exports